/* eslint-disable import/prefer-default-export */
import { SHOW_METERED_ACCESS_BANNER, HIDE_METERED_ACCESS_BANNER } from '../constants';

export function showMeteredAccessBanner(payload) {
  return dispatch => {
    dispatch({
      type: SHOW_METERED_ACCESS_BANNER,
      payload,
    });
  };
}

export function hideMeteredAccessBanner(payload) {
  return dispatch => {
    dispatch({
      type: HIDE_METERED_ACCESS_BANNER,
      payload,
    });
  };
}
